import React, { useCallback, useState } from "react";

import ConfirmModal from "../ConfirmModal";

interface UpdateRecordPanelProps {
  instructions: string;
  handleAction: any;
  assignedTo: Array<string>;
  steps: Array<any>;
  step: number;
}

const UpdateRecordPanel = ({
  instructions,
  handleAction,
  steps,
  step,
  assignedTo
}: UpdateRecordPanelProps) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [action, setAction] = useState("");
  const [message, setMessage] = useState("Are you sure?");

  const [note, setNote] = useState("");

  const showModal = useCallback((action, message) => {
    console.log("showModal", action, message);
    setAction(action);
    setMessage(message);
    setModalOpen(true);
  }, []);

  // determine step
  const currentStep = steps[step - 1];

  console.log("currentStep", currentStep);

  return (
    <div className="bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200 mb-8">
      <div className="px-4 py-5 sm:px-6 bg-gray-50">
        <h2 className="font-bold text-gray-700">Update Record</h2>
      </div>
      <div className="px-4 py-5 sm:p-6 ">
        <div className="col-span-6 sm:col-span-3 mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Instructions
          </label>
          <p className="text-sm text-gray-500 italic">{instructions}</p>
        </div>
        <div className="col-span-6 sm:col-span-3 mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Assigned To
          </label>
          <p className="text-sm text-gray-500 italic">
            {currentStep.approvers && currentStep.approvers.join(", ")}
          </p>
        </div>
        <div className="mb-4">
          <label
            htmlFor="comments"
            className="block text-sm font-medium text-gray-700"
          >
            Notes
          </label>
          <div className="mt-1">
            <textarea
              id="comments"
              name="comments"
              onChange={(event) => setNote(event.target.value)}
              rows={3}
              className="shadow-sm focus:ring-green-500 bg-gray-50 focus:border-green-500 block w-full sm:text-sm border border-gray-300 rounded-md"
              placeholder="Enter comments here..."
              defaultValue={""}
            />
          </div>
        </div>
        <div className="flex justify-end mb-4">
          <button
            disabled={!note}
            title="Save note but do not change status"
            onClick={() =>
              showModal(
                "note",
                "This will add a note to the application but will not change its status or step in the process."
              )
            }
            className="w-full py-2 px-4 border bg-gradient-to-b from-blue-600 to-blue-700 hover:from-blue-500 hover:to-blue-600  border-gray-300 rounded-md shadow-sm text-sm font-medium text-white cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Add Note
          </button>
          <button
            disabled={!note}
            onClick={() =>
              showModal(
                "approve",
                "Approving this application will record your note and send it to the next step in the process."
              )
            }
            className="w-full ml-3 bg-gradient-to-b from-green-600 to-green-700 hover:from-green-500 hover:to-green-600  inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 focus:ring-green-500"
          >
            Approve
          </button>
          <button
            disabled={!note}
            onClick={() =>
              showModal(
                "reviewer-reject",
                "Rejecting this application will mark the application as deficient and notify the NCF Administrators."
              )
            }
            className="w-full ml-3 bg-gradient-to-b from-red-600 to-red-700 hover:from-red-500 hover:to-red-600  inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 focus:ring-red-500"
          >
            Reject
          </button>
        </div>
        {currentStep.id === steps[steps.length - 1].id && (
          <div className="flex justify-end">
            <button
              disabled={!note}
              onClick={() =>
                showModal(
                  "conditional-approval",
                  "Conditional approval will put the application into a final status but indicates to administrators that there is still additional work to be done."
                )
              }
              className="w-full mb-2 bg-gradient-to-b from-gray-50 to-gray-100 hover:from-gray-100 hover:to-gray-200  inline-flex justify-center py-2 px-4 border border-green-500 shadow-sm text-sm font-medium rounded-md text-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 focus:ring-green-600"
            >
              Conditional Approval
            </button>
          </div>
        )}
      </div>
      {modalOpen && (
        <ConfirmModal
          message={message}
          handleClose={() => {
            setModalOpen(false);
          }}
          handleAction={() => {
            console.log("handleAction", action, note, currentStep);
            handleAction(action, note, currentStep);
          }}
        />
      )}
    </div>
  );
};

export default UpdateRecordPanel;
